(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[564],{

/***/ 9881:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections",
      function () {
        return __webpack_require__(9532);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1931:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9473);
/* harmony import */ var _data_Feature_collections_data__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1843);





var Explore_collection_item = function(param) {
    var itemFor = param.itemFor;
    var sortedCollectionData = useSelector(function(state) {
        return state.counter;
    }).sortedCollectionData;
    var ref = useState([]), itemData = ref[0], setItemData = ref[1];
    useEffect(function() {
        if (itemFor === "userPage") {
            setItemData(Feature_collections_data.slice(0, 4));
            console.log(itemData);
        } else {
            setItemData(sortedCollectionData);
        }
    }, [
        sortedCollectionData,
        itemFor
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: itemData.map(function(item) {
            var id = item.id, bigImage = item.bigImage, subImage1 = item.subImage1, subImage2 = item.subImage2, subImage3 = item.subImage3, userImage = item.userImage, title = item.title, itemsCount = item.itemsCount, userName = item.userName;
            return /*#__PURE__*/ _jsx("article", {
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "dark:bg-jacarta-700 dark:border-jacarta-700 border-jacarta-100 rounded-2xl border bg-white p-[1.1875rem] transition-shadow hover:shadow-lg",
                    children: [
                        /*#__PURE__*/ _jsx(Link, {
                            href: "/collection/avatar_1",
                            children: /*#__PURE__*/ _jsxs("a", {
                                className: "flex space-x-[0.625rem]",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "w-[74.5%]",
                                        children: /*#__PURE__*/ _jsx("img", {
                                            src: bigImage,
                                            alt: "item 1",
                                            className: "h-full w-full rounded-[0.625rem] object-cover",
                                            loading: "lazy"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs("span", {
                                        className: "flex w-1/3 flex-col space-y-[0.625rem]",
                                        children: [
                                            /*#__PURE__*/ _jsx("img", {
                                                src: subImage1,
                                                alt: "item 1",
                                                className: "h-full rounded-[0.625rem] object-cover",
                                                loading: "lazy"
                                            }),
                                            /*#__PURE__*/ _jsx("img", {
                                                src: subImage2,
                                                alt: "item 1",
                                                className: "h-full rounded-[0.625rem] object-cover",
                                                loading: "lazy"
                                            }),
                                            /*#__PURE__*/ _jsx("img", {
                                                src: subImage3,
                                                alt: "item 1",
                                                className: "h-full rounded-[0.625rem] object-cover",
                                                loading: "lazy"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(Link, {
                            href: "/collection/avatar_1",
                            children: /*#__PURE__*/ _jsx("a", {
                                className: "font-display hover:text-accent dark:hover:text-accent text-jacarta-700 mt-4 block text-base dark:text-white",
                                children: title
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "mt-2 flex items-center justify-between text-sm font-medium tracking-tight",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex flex-wrap items-center",
                                    children: [
                                        /*#__PURE__*/ _jsx(Link, {
                                            href: "/user/avatar_6",
                                            children: /*#__PURE__*/ _jsx("a", {
                                                className: "mr-2 shrink-0",
                                                children: /*#__PURE__*/ _jsx("img", {
                                                    src: userImage,
                                                    alt: "owner",
                                                    className: "h-5 w-5 rounded-full"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "dark:text-jacarta-400 mr-1",
                                            children: "by"
                                        }),
                                        /*#__PURE__*/ _jsx(Link, {
                                            href: "/user/avatar_6",
                                            children: /*#__PURE__*/ _jsx("a", {
                                                className: "text-accent",
                                                children: /*#__PURE__*/ _jsx("span", {
                                                    children: userName
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("span", {
                                    className: "dark:text-jacarta-300 text-sm",
                                    children: [
                                        itemsCount,
                                        " Items"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }, id);
        })
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Explore_collection_item)));


/***/ }),

/***/ 9532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ collections; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./data/categories_data.js
var categories_data = __webpack_require__(3996);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
// EXTERNAL MODULE: ./components/component.js + 17 modules
var component = __webpack_require__(3625);
// EXTERNAL MODULE: ./data/Feature_collections_data.js
var Feature_collections_data = __webpack_require__(1843);
// EXTERNAL MODULE: ./redux/counterSlice.js
var counterSlice = __webpack_require__(8362);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
;// CONCATENATED MODULE: ./components/dropdown/collection_dropdown.jsx




var Collection_dropdown = function() {
    var dispatch = useDispatch();
    var ref = useState(null), dropdownItemActive = ref[0], setDropdownItemActive = ref[1];
    var ref1 = useState(false), dropdownShow = ref1[0], setDropdownShow = ref1[1];
    var handleDropdown = function() {
        window.addEventListener("click", function(w) {
            if (w.target.closest(".dropdown-toggle")) {
                if (dropdownShow) {
                    setDropdownShow(false);
                } else {
                    setDropdownShow(true);
                }
            } else {
                setDropdownShow(false);
            }
        });
    };
    var dropdownItemText = [
        {
            id: 1,
            text: "trending"
        },
        {
            id: 2,
            text: "top"
        },
        {
            id: 3,
            text: "recent"
        }, 
    ];
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "dropdown relative my-1 cursor-pointer",
            children: [
                /*#__PURE__*/ _jsxs("button", {
                    className: "dark:bg-jacarta-700 dropdown-toggle border-jacarta-100 dark:border-jacarta-600 inline-flex w-48 items-center justify-between rounded-lg border bg-white py-2 px-3 text-sm dark:text-white",
                    onClick: handleDropdown,
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "font-display",
                            children: "Trending"
                        }),
                        /*#__PURE__*/ _jsxs("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24",
                            width: "24",
                            height: "24",
                            className: "fill-jacarta-500 h-4 w-4 dark:fill-white",
                            children: [
                                /*#__PURE__*/ _jsx("path", {
                                    fill: "none",
                                    d: "M0 0h24v24H0z"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: dropdownShow ? " dark:bg-jacarta-800 z-10 max-w-sm w-[13rem] whitespace-nowrap rounded-xl bg-white py-4 px-2 text-left shadow-xl absolute top-full right-0 show" : " dark:bg-jacarta-800 z-10 max-w-sm w-[13rem] whitespace-nowrap rounded-xl bg-white py-4 px-2 text-left shadow-xl absolute top-full right-0 hidden",
                    children: dropdownItemText.map(function(param) {
                        var id = param.id, text = param.text;
                        return /*#__PURE__*/ _jsxs("button", {
                            className: "dropdown-item font-display text-jacarta-700 dark:hover:bg-jacarta-600 hover:bg-jacarta-100 flex w-full items-center justify-between rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white",
                            onClick: function() {
                                setDropdownItemActive(id);
                                dispatch(updateCollectionData(text));
                            },
                            children: [
                                text,
                                dropdownItemActive === id && /*#__PURE__*/ _jsxs("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 24 24",
                                    width: "24",
                                    height: "24",
                                    className: "fill-accent h-4 w-4",
                                    children: [
                                        /*#__PURE__*/ _jsx("path", {
                                            fill: "none",
                                            d: "M0 0h24v24H0z"
                                        }),
                                        /*#__PURE__*/ _jsx("path", {
                                            d: "M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"
                                        })
                                    ]
                                })
                            ]
                        }, id);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var collection_dropdown = ((/* unused pure expression or super */ null && (Collection_dropdown)));

// EXTERNAL MODULE: ./components/collectrions/explore_collection_item.jsx
var explore_collection_item = __webpack_require__(1931);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./components/Meta.jsx
var Meta = __webpack_require__(7901);
;// CONCATENATED MODULE: ./pages/collections/index.jsx
/* eslint-disable @next/next/no-img-element */ 












var Explore_collection = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(Feature_collections_data/* default */.Z), collectionFilteredData = ref[0], setCollectionFilteredData = ref[1];
    var ref1 = (0,react.useState)(0), filterVal = ref1[0], setFilterVal = ref1[1];
    var handleItemFilter = function(text) {
        if (text === "all") {
            setCollectionFilteredData(Feature_collections_data/* default */.Z);
        } else {
            setCollectionFilteredData(Feature_collections_data/* default.filter */.Z.filter(function(item) {
                return item.category === text;
            }));
        }
    };
    (0,react.useEffect)(function() {
        dispatch((0,counterSlice/* collectCollectionData */.OQ)(collectionFilteredData.slice(0, 8)));
    }, [
        dispatch,
        collectionFilteredData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default */.Z, {
                title: "Explore Collections"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "relative mt-24 lg:pb-48 pb-24",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
                        className: "pointer-events-none absolute inset-0 -z-10 dark:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/gradient_light.jpg",
                            alt: "gradient",
                            className: "h-full"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component/* All_collection */.o8, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var collections = (Explore_collection);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [228,697,794,717,668,131,843,968,774,888,179], function() { return __webpack_exec__(9881); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);